import { render } from "./MdTabs.vue?vue&type=template&id=3a9292b4&scoped=true&ts=true"
import script from "./MdTabs.vue?vue&type=script&lang=ts"
export * from "./MdTabs.vue?vue&type=script&lang=ts"

import "./MdTabs.vue?vue&type=style&index=0&id=3a9292b4&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9292b4"]])

export default __exports__